(function () {
    'use strict';

    var STORAGE_KEY = 'ballangk_chat_widget_position';
    var EDGE_GAP = 12;
    var DOCK_OFFSET = 24;
    var PANEL_GAP = 12;
    var DRAG_THRESHOLD = 6;
    var WAIT_TIMEOUT = 30000;

    function readPosition() {
        var position = null;

        try {
            position = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
        } catch (error) {
            position = null;
        }

        return position && isFinite(position.x) && isFinite(position.y) ? position : null;
    }

    function savePosition(position) {
        try {
            window.localStorage.setItem(STORAGE_KEY, JSON.stringify(position));

            return true;
        } catch (error) {
            return false;
        }
    }

    function clamp(value, min, max) {
        return Math.min(Math.max(value, min), Math.max(min, max));
    }

    function viewportWidth() {
        return document.documentElement.clientWidth || window.innerWidth;
    }

    function viewportHeight() {
        return window.innerHeight || document.documentElement.clientHeight;
    }

    function makeDraggable(root, button) {
        var panel = root.querySelector('#_ocw_panel');
        var ratio = readPosition();
        var pointer = null;
        var suppressClick = false;

        root.setAttribute('data-draggable', '1');
        button.style.touchAction = 'none';
        button.style.cursor = 'grab';

        function buttonSize() {
            return button.offsetWidth || 60;
        }

        function travel() {
            var size = buttonSize();

            return {
                x: viewportWidth() - size - EDGE_GAP * 2,
                y: viewportHeight() - size - EDGE_GAP * 2,
            };
        }

        function dockPanel(left, top) {
            var size = buttonSize();
            var height = viewportHeight();
            var dockLeft = left + size / 2 < viewportWidth() / 2;
            var spaceAbove = top - PANEL_GAP - EDGE_GAP;
            var spaceBelow = height - top - size - PANEL_GAP - EDGE_GAP;
            var openAbove = spaceAbove >= spaceBelow;

            root.style.pointerEvents = 'none';
            root.style.left = dockLeft ? DOCK_OFFSET + 'px' : 'auto';
            root.style.right = dockLeft ? 'auto' : DOCK_OFFSET + 'px';
            root.style.alignItems = dockLeft ? 'flex-start' : 'flex-end';
            root.style.top = openAbove ? 'auto' : top + size + PANEL_GAP + 'px';
            root.style.bottom = openAbove ? height - top + PANEL_GAP + 'px' : 'auto';

            if (panel) {
                panel.style.pointerEvents = 'auto';
                panel.style.maxHeight = Math.max(openAbove ? spaceAbove : spaceBelow, 0) + 'px';
            }
        }

        function place(left, top) {
            var size = buttonSize();
            var safeLeft = clamp(left, EDGE_GAP, viewportWidth() - size - EDGE_GAP);
            var safeTop = clamp(top, EDGE_GAP, viewportHeight() - size - EDGE_GAP);

            button.style.position = 'fixed';
            button.style.left = safeLeft + 'px';
            button.style.top = safeTop + 'px';
            button.style.right = 'auto';
            button.style.bottom = 'auto';
            button.style.pointerEvents = 'auto';

            dockPanel(safeLeft, safeTop);

            return { left: safeLeft, top: safeTop };
        }

        function placeFromRatio() {
            if (!ratio) {
                return;
            }

            var range = travel();

            place(EDGE_GAP + ratio.x * range.x, EDGE_GAP + ratio.y * range.y);
        }

        function rememberRatio(position) {
            var range = travel();

            ratio = {
                x: range.x > 0 ? clamp((position.left - EDGE_GAP) / range.x, 0, 1) : 1,
                y: range.y > 0 ? clamp((position.top - EDGE_GAP) / range.y, 0, 1) : 1,
            };

            savePosition(ratio);
        }

        button.addEventListener('pointerdown', function (event) {
            if (event.button !== 0) {
                return;
            }

            var rect = button.getBoundingClientRect();
            var scaleOffsetX = (rect.width - button.offsetWidth) / 2;
            var scaleOffsetY = (rect.height - button.offsetHeight) / 2;

            pointer = {
                id: event.pointerId,
                startX: event.clientX,
                startY: event.clientY,
                originLeft: rect.left + scaleOffsetX,
                originTop: rect.top + scaleOffsetY,
                moved: false,
                position: null,
            };

            button.setPointerCapture(event.pointerId);
        });

        button.addEventListener('pointermove', function (event) {
            if (!pointer || pointer.id !== event.pointerId) {
                return;
            }

            var deltaX = event.clientX - pointer.startX;
            var deltaY = event.clientY - pointer.startY;

            if (!pointer.moved) {
                if (Math.abs(deltaX) < DRAG_THRESHOLD && Math.abs(deltaY) < DRAG_THRESHOLD) {
                    return;
                }

                pointer.moved = true;
                button.style.cursor = 'grabbing';
            }

            event.preventDefault();
            pointer.position = place(pointer.originLeft + deltaX, pointer.originTop + deltaY);
        });

        function finishDrag(event) {
            if (!pointer || pointer.id !== event.pointerId) {
                return;
            }

            if (pointer.moved && pointer.position) {
                rememberRatio(pointer.position);
                suppressClick = event.type === 'pointerup';
            }

            button.style.cursor = 'grab';
            pointer = null;
        }

        button.addEventListener('pointerup', finishDrag);
        button.addEventListener('pointercancel', finishDrag);

        root.addEventListener(
            'click',
            function (event) {
                if (!suppressClick || !button.contains(event.target)) {
                    return;
                }

                suppressClick = false;
                event.preventDefault();
                event.stopPropagation();
            },
            true
        );

        window.addEventListener('resize', placeFromRatio);

        placeFromRatio();
    }

    function tryInit() {
        var root = document.getElementById('_oc_widget_root');
        var button = document.getElementById('_ocw_btn');

        if (!root || !button) {
            return false;
        }

        if (root.getAttribute('data-draggable') !== '1') {
            makeDraggable(root, button);
        }

        return true;
    }

    function waitForWidget() {
        if (tryInit() || !window.MutationObserver) {
            return;
        }

        var observer = new MutationObserver(function () {
            if (tryInit()) {
                observer.disconnect();
            }
        });

        observer.observe(document.body, { childList: true });

        window.setTimeout(function () {
            observer.disconnect();
        }, WAIT_TIMEOUT);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', waitForWidget);
    } else {
        waitForWidget();
    }
})();
